import { ArrowDownLeft, ArrowUpRight, Receipt, Send, Landmark, Coins } from 'lucide-react';
import type { OperationMode } from './types';

interface ModeTabsToggleProps {
  mode: OperationMode;
  onModeChange: (mode: OperationMode) => void;
  buyLabel: string;
  sellLabel: string;
  expenseLabel: string;
  transferLabel?: string;
  ownerLabel?: string;
  cryptoLabel?: string;
}

export function ModeTabsToggle({ mode, onModeChange, buyLabel, sellLabel, expenseLabel, transferLabel = 'TRANSFER', ownerLabel = 'OWNER', cryptoLabel = 'CRYPTO' }: ModeTabsToggleProps) {
  return (
    <div className="flex border-b border-border bg-surface-hover">
      <button
        type="button"
        className={`
          flex-1 flex items-center justify-center gap-2 py-4 px-6
          text-sm font-bold cursor-pointer transition-colors
          ${mode === 'buy'
            ? 'bg-surface text-ctp-green shadow-sm border-t-2 border-ctp-green'
            : 'text-foreground-muted hover:text-foreground border-t-2 border-transparent'
          }
        `}
        onClick={() => onModeChange('buy')}
      >
        <ArrowDownLeft size={18} />
        {buyLabel}
      </button>
      <button
        type="button"
        className={`
          flex-1 flex items-center justify-center gap-2 py-4 px-6
          text-sm font-bold cursor-pointer transition-colors
          ${mode === 'sell'
            ? 'bg-surface text-ctp-red shadow-sm border-t-2 border-ctp-red'
            : 'text-foreground-muted hover:text-foreground border-t-2 border-transparent'
          }
        `}
        onClick={() => onModeChange('sell')}
      >
        <ArrowUpRight size={18} />
        {sellLabel}
      </button>
      <button
        type="button"
        className={`
          flex-1 flex items-center justify-center gap-2 py-4 px-6
          text-sm font-bold cursor-pointer transition-colors
          ${mode === 'expense'
            ? 'bg-surface text-ctp-peach shadow-sm border-t-2 border-ctp-peach'
            : 'text-foreground-muted hover:text-foreground border-t-2 border-transparent'
          }
        `}
        onClick={() => onModeChange('expense')}
      >
        <Receipt size={18} />
        {expenseLabel}
      </button>
      <button
        type="button"
        className={`
          flex-1 flex items-center justify-center gap-2 py-4 px-6
          text-sm font-bold cursor-pointer transition-colors
          ${mode === 'transfer'
            ? 'bg-surface text-ctp-blue shadow-sm border-t-2 border-ctp-blue'
            : 'text-foreground-muted hover:text-foreground border-t-2 border-transparent'
          }
        `}
        onClick={() => onModeChange('transfer')}
      >
        <Send size={18} />
        {transferLabel}
      </button>
      <button
        type="button"
        className={`
          flex-1 flex items-center justify-center gap-2 py-4 px-6
          text-sm font-bold cursor-pointer transition-colors
          ${mode === 'owner'
            ? 'bg-surface text-ctp-mauve shadow-sm border-t-2 border-ctp-mauve'
            : 'text-foreground-muted hover:text-foreground border-t-2 border-transparent'
          }
        `}
        onClick={() => onModeChange('owner')}
      >
        <Landmark size={18} />
        {ownerLabel}
      </button>
      <button
        type="button"
        className={`
          flex-1 flex items-center justify-center gap-2 py-4 px-6
          text-sm font-bold cursor-pointer transition-colors
          ${mode === 'crypto'
            ? 'bg-surface text-ctp-teal shadow-sm border-t-2 border-ctp-teal'
            : 'text-foreground-muted hover:text-foreground border-t-2 border-transparent'
          }
        `}
        onClick={() => onModeChange('crypto')}
      >
        <Coins size={18} />
        {cryptoLabel}
      </button>
    </div>
  );
}
